var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"nice-icons",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 100 100"}},[_c('defs',_vm._l((_vm.SYMBOL_LIST),function(symbol){return _c(symbol,{key:symbol,tag:"component",attrs:{"prefix":_vm.prefix}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }